import 'css-chunksrc/client/pages/projectPage/timeSheetPage/resourceTimeOverview/styles.scss';export default {
  "resourceTimeOverview": "_resourceTimeOverview_12wk0_1",
  "cell": "_cell_12wk0_8",
  "text": "_text_12wk0_22"
};